import * as React from "react";
import { MainLayout } from "../../components/Layout";
import Headline from "../../components/Headline";
import LinkButton from "../../components/LinkButton";
import { URL_PATHS } from "../../routes";
import "./styles.scss";
import { oneLink } from "../../shared/oneLink";
import AnchorButton from "../../components/AnchorButton";

const PaymentRestartFinish = () => {
    return (
        <MainLayout>
            <Headline>有料会員プランの継続設定完了</Headline>
            <section className="payment-restart-finish">
                <p className="finish-message">
                    ありがとうございます！
                    <br />
                    パートナーエージェントAppの有料会員プランが引き続きご利用いただけます！
                    <br />
                    アプリを開いてサービスをご利用ください。
                </p>

                <div className="user-action">
                    <AnchorButton href={oneLink()}>アプリを開く</AnchorButton>
                    <LinkButton color="secondary" to={URL_PATHS.myPage()}>
                        マイページへ
                    </LinkButton>
                </div>
            </section>
        </MainLayout>
    );
};

export default PaymentRestartFinish;
